<template>
<div>
  <div>
    <div
      @click.stop.prevent="toggleOptions">
      <div
        v-show="opened"
        @click.stop>
        <div
          v-for="option in optionsParsed"
          :key="option.id"
          class="faixa-container">
          <div class="faixa-option">
            <div class="faixa-option-info">
              <b>
                <span :style="{ color: colorNameLote}">
                  [{{ option.nome_lote.toUpperCase() }}]
                </span> 
                {{ option.nome.toUpperCase() }}
              </b>
              <br>
              <span
                v-if="getCurrentPrice(option).precoDe"
                style="color: lightgray; text-decoration: line-through;">{{ formatMoney(getCurrentPrice(option).precoDe) }}&nbsp;
              </span>
              <span
                v-if="cobrarTaxa"
                :style="{ color: primaryColor, fontWeight: 500 }">
                {{ formatMoney(getCurrentPrice(option).preco) }}
                <span>(+ {{ formatMoney(
                  calculateTaxForNetValue( getCurrentPrice(option).preco, taxa)) 
                }} taxa)</span>
                <br>
                {{ option.descricao }}
              </span>
              <span
                v-else
                :style="{ color: primaryColor, fontWeight: 500 }">
                {{ formatMoney(getCurrentPrice(option).preco) }}
                ({{ option.descricao }})
              </span>
              <br>
              <div
                v-if="option.combo"
                style="font-size: 10px;">
                <div
                  v-for="(dateTime, i) in option.disponibilidade_id"
                  :key="i">
                  <span><b>{{ option.nomesFaixasOriginais[i].toUpperCase() }}</b> - </span>
                  <span>{{ getAvailableForCombo(option.datas_originais[i]) }} {{ option.label[i] ? `- ${option.label[i]}` : '' }}</span>
                  <span v-if="option.datas_originais.length == 1">
                    <br> <b>{{ 'CASADINHA' }}</b></span>
                </div>
              </div>
              <span
                v-else
                style="font-size: 10px;">{{ getAvailable(option.disponibilidade_id) }}</span>
            </div>
            <div
              class="faixa-option-quantity"
              translate="no">
              <div :class="{'disabled-quantity': getCurrentQuantidade(option) == 0, 'add-quantity': getCurrentQuantidade(option) > 0 }">
                <i
                  class="fa-solid fa-minus p-1"
                  @click="sub(option); setValidateQuantity(option, false, true);" />
              </div>
              <div class="faixa-option-quantity-display">
                <strong>{{ getCurrentQuantidade(option) }}</strong>
              </div>
              <div :class="{'add-quantity': !validateQuantity(option), 'disabled-quantity': validateQuantity(option) }">
                <i
                  :class="{'fa-solid fa-plus p-1': true }"
                  @click="add(option); setValidateQuantity(option, true, false);" />
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="$props.selectedAvailability && optionsParsed.length == 0"
          class="faixa-container">
          <span class="p-4">Nenhum ingresso disponível.</span>
        </div>
        <div v-if="isDependentOnly">
          <small>É necessário adicionar ao menos 1 não dependente</small>
        </div>
        <div
          v-if="minVenda > 1 || maxVenda < Infinity"
          class="compliance-alert">
          <small v-if="minVenda > 1 && maxVenda < Infinity">O máximo de vagas para a compra dessa atividade por pessoa é: {{ maxVenda }} (caso tenha disponibilidade). E no mínimo {{ minVenda }}.</small>
          <small v-if="minVenda <= 1 && maxVenda < Infinity">O máximo de vagas para a compra dessa atividade por pessoa é: {{ maxVenda }} (caso tenha disponibilidade).</small>
          <small v-if="minVenda > 1 && maxVenda >= Infinity">O mínimo de vagas para a compra dessa atividade por pessoa é: {{ minVenda }} (caso tenha disponibilidade).</small>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import moment from 'moment';
import 'moment/locale/pt-br';
export default {
  name:'InputTicketsEvento',
  props: {
    value: {
      type: Array,
      default: () => [],
      required: false
    },
    selectedDate: {
      validator: (v) => v instanceof Date || v == null,
      default: () => null,
      required: false
    },
    options: {
      type: Object,
      default: () => ({}),
      required: true
    },
    primaryColor: {
      type: String,
      default: () => '#FF0000',
      required: true
    },
    min: {
      type: String,
      default: () => '1',
      required: true
    },
    max: {
      type: String,
      default: () => '9999',
      required: true
    },
    isMobile: {
      type: Boolean,
      default: () => false,
      required: false,
    },
    nomeItem: {
      type:  String,
      default: () => 'PESSOAS',
      required: false
    },
    moeda: {
      type: String,
      default: () => 'BRL',
      required: true
    },
    available: {
      type: Array,
      default: () => [],
      required: true
    },
    selectedAvailability: { 
      type: Number,
      default: () => 0,
      required: true
    },
    tipoPasseio: {
      type: String, 
      default: () => '',
      required: true
    },
    cobrarTaxa: {
      type: Boolean,
      default: () => false,
      required: true
    },
    taxa:{
      type: Number,
      default: () => 10,
    }
  },
  emits: ['input', 'on-options-open-state-change', 'on-complience-state-change'],
  data() {
    return { opened: false };
  },
  computed: {
    optionsParsed() {
      const ops = this.$props.options;
      const selectedAvailability = this.$props.selectedAvailability;
      const chaves = Object.keys(ops);
      if(chaves.length <= 0) {
        return [];
      }
      if(!selectedAvailability){
        return [];
      }

      const r = chaves.map(chave => ops[chave])
        .filter(option => {
          if (option.combo) {
            return option.disponibilidade_id.includes(selectedAvailability);
          } else {
            return option.disponibilidade_id === selectedAvailability;
          }
        });

      r.sort((a, b) => Number(a.ordem) - Number(b.ordem));

      return r;
    },
    optionsParsedNotFilterAvailability() {
      const ops = this.$props.options;
      const chaves = Object.keys(ops);
      if(chaves.length <= 0) {
        return [];
      }

      const r = [];
      chaves.forEach((chave) => {
        r.push(ops[chave]);
      });

      r.sort((a, b) => Number(a.ordem)-Number(b.ordem));

      return r;
    },

    isDependentOnly() {
      if(!this.$props.value || this.$props.value.length <= 0) {
        return false;
      }
      for (let i = 0; i < this.$props.value.length; i++) {
        const faixa = this.$props.value[i];
        if(!faixa.dependente) {
          return false;
        }
      }
      return true;
    },
    respectMinMax() {
      if(!this.$props.value || this.$props.value.length <= 0) {
        return false;
      }
      return this.somaQuantidade >= this.minVenda && this.somaQuantidade <= this.maxVenda;
    },
    inCompliance() {
      return !this.isDependentOnly && this.respectMinMax;
    },
    minVenda() {
      const min = Number(this.$props.min);
      if(isNaN(min)) {
        return 1;
      }
      return min;
    },
    maxVenda() {
      const max = Number(this.$props.max);
      if(isNaN(max) || max < this.min) {
        return Infinity;
      }
      return max;
    },
    somaQuantidade() {
      let soma = 0;
      for (let i = 0; i < this.$props.value.length; i++) {
        const faixa = this.$props.value[i];
        soma += faixa.quantidade;
      }
      return soma;
    },
    resumo() {
      if(!this.$props.value.length || this.$props.value.length <= 0) {
        return 'Selecione';
      }
      let r = '';
      this.$props.value.forEach(faixa => {
        const infoFaixa = this.getFaixaById(faixa.id);
        r += faixa.quantidade.toString() + ' ' + infoFaixa.nome + ', ';
      });
      return r.slice(0, -2);
    },
    colorNameLote(){
      return '#E88A1D';
    }
  },
  watch: {
    opened() {
      this.$emit('on-options-open-state-change', this.opened);
    },
    inCompliance() {
      this.$emit('on-complience-state-change', this.inCompliance);
    },
  },
  mounted() {
    this.$emit('on-complience-state-change', this.inCompliance);
    this.opened = true;
  },
  methods: {
    sub(faixa) {
      this.mudarQuantidade(faixa, -1);
    },
    add(faixa) {
      this.mudarQuantidade(faixa, 1);
    },
    mudarQuantidade(faixa, quantidade) {
      const minLimit = 0;
      const vagasRestantes = this.maxVenda - this.somaQuantidade;
      if(quantidade > vagasRestantes) {
        return false;
      }

      const current = JSON.parse(JSON.stringify(this.$props.value));
      for (let i = 0; i < current.length; i++) {
        const faixaAtual = current[i];
        if(faixaAtual.id == faixa.id) {
          faixaAtual.quantidade += quantidade;
          if(faixaAtual.quantidade < minLimit) {
            return false;
          }
          this.$emit('input', current.filter(faixa => faixa.quantidade > 0));
          return true;
        }
      }
      if(quantidade < minLimit) {
        return false;
      }
      current.push({
        'id': faixa.id,
        'faixa_etaria_id': faixa.faixa_etaria_id,
        'ordem': faixa.ordem,
        'quantidade': quantidade,
        'preco': this.getCurrentPrice(faixa),
        'dependente': faixa.dependente == 1,
        'disponibilidade_id': faixa.disponibilidade_id,
      });
      current.sort((a, b) => Number(a.ordem)-Number(b.ordem));
      this.$emit('input', current.filter(faixa => faixa.quantidade > 0));
      return true;
    },
    getCurrentQuantidade(faixa) {
      for (let i = 0; i < this.$props.value.length; i++) {
        const faixaAdicionada = this.$props.value[i];
        if(faixaAdicionada.id == faixa.id) {
          return faixaAdicionada.quantidade;
        }
      }
      return 0;
    },
    toggleOptions() {
      this.opened = !this.opened;
    },
    formatMoney(price) {
      let locale = 'pt-Br';

      if (this.$props.moeda === 'USD') {
        locale = 'en-US';
      }

      if(price <= 0 || price === null) {
        return 'Gratuito';
      }
            
      return Number(price).toLocaleString(locale, { style: 'currency', currency: this.$props.moeda });
    },
    getCurrentPrice(priceObj) {
      const defaultPrice = {
        'id': priceObj.id,
        'precoDe': null,
        'preco': parseFloat(priceObj.preco),
        'precoDesconto': priceObj.preco_desconto !== null ? parseFloat(priceObj.preco_desconto) : null
      };
      if(!this.$props.selectedDate) {
        return defaultPrice;
      }

      return defaultPrice;
    },
    getFaixaById(id) {
      for (let i = 0; i < this.optionsParsed.length; i++) {
        const option = this.optionsParsed[i];
        if(option.id == id) {
          return option;
        }
      }
      return null;
    },
    getAvailable(available_id){
      const available = this.$props.available.filter(item => item.id == available_id);
      let dateTime = null;
      if (available.length > 0) {
        available.forEach(item => {
          const date = moment(item.date);
          const formattedDate = date.format('DD [de] MMMM [de] YYYY');

          switch (this.$props.tipoPasseio) {
          case 'intervalo_dias':
            dateTime = `${formattedDate} - ${item.label}`;
            break;
          case 'livre':
            dateTime = `${formattedDate} - ${item.label}`;
            break;    
          case 'turno':
            dateTime = `${formattedDate} - ${item.label}`;
            break;
          case 'dia_inteiro':
            dateTime = `${formattedDate} - ${item.label}`;
            break;      
                    
          default:
            dateTime = `${formattedDate} - ${item.label}h`;
          }
        });
      }
            
      if(dateTime){
        return dateTime;
      }

      return '';
    },
    getAvailableForCombo(date) {
      const newDate = moment(date);
      const formattedDate = newDate.format('DD [de] MMMM [de] YYYY');
      return formattedDate;
    },
    validateQuantity(ticket){
            
      if(!ticket ){
        return false;
      }

      if (
        !ticket.combo && 
        ticket.total_vagas === 0 || 
        ticket.quantidade_vagas_disponivel === 0 || 
        (ticket.quantidade != 0 && ticket.quantidade == this.$props.max)
      ) {
        return true;
      }

      if(
        ticket.combo &&
        ticket.total_vagas == 0 ||
        ticket.quantidade_vagas_disponivel == 0 ||
        (ticket.quantidade != 0 && ticket.quantidade == this.$props.max)            
      ){
        return true;
      }

      return false;
    },
    setValidateQuantity(ticket, add = false, sub = false){
      if(ticket.quantidade == null){
        ticket.quantidade = 0;
      }

      if(add){
        ticket.quantidade++;
      }

      if (sub) {
        ticket.quantidade--;
      }

      if (ticket.vendas_atuais == null) {
        ticket.vendas_atuais = 0;
      }
               
      if(ticket.total_vagas == null){
        ticket.total_vagas = ticket.quantidade_vagas_disponivel;
      }
          
      if (ticket.combo) {
        ticket.precos_originais_ids.forEach(originalId => {
          const index = this.optionsParsedNotFilterAvailability.findIndex(item => item.id == originalId);
          let originalAgeRange = null;
          if( index !== -1){
            originalAgeRange = this.optionsParsedNotFilterAvailability[index];
          }
          if (originalAgeRange) {
            if (originalAgeRange.vendas_atuais == null) {
              originalAgeRange.vendas_atuais = 0;
            }

            if(originalAgeRange.total_vagas == null){
              originalAgeRange.total_vagas = originalAgeRange.quantidade_vagas_disponivel;
            }
          }
        });

        ticket.precos_originais_ids.forEach(originalId => {
          const originalAgeRange = this.optionsParsedNotFilterAvailability.find(item => item.id === originalId);
          if (originalAgeRange) {

            if(add){
              originalAgeRange.vendas_atuais++;
              originalAgeRange.total_vagas--;
            }
            if(sub){
              originalAgeRange.vendas_atuais--;
              originalAgeRange.total_vagas++;
            }
          }
        });
        if(add){
          ticket.total_vagas--;
          ticket.vendas_atuais++;
        }
        if(sub){
          ticket.total_vagas++;
          ticket.vendas_atuais--;
        }
      } else {
        if(add){
          ticket.total_vagas--;
          ticket.vendas_atuais++;
          const combos = this.optionsParsedNotFilterAvailability.filter(item => 
            item.combo && item.precos_originais_ids.includes(ticket.id)
          );
                    
          if(combos && combos.length > 0){
            combos.forEach(item => {
              if (item.vendas_atuais == null) {
                item.vendas_atuais = 0;
              }
                   
              if(item.total_vagas == null){
                item.total_vagas = item.quantidade_vagas_disponivel;
              }
                            
              if(item.total_vagas >= ticket.total_vagas){
                item.total_vagas = ticket.total_vagas; 
              }
            });
          }
        }
        if(sub){
          ticket.total_vagas++;
          ticket.vendas_atuais--;
          const combos = this.optionsParsedNotFilterAvailability.filter(item => 
            item.combo && item.precos_originais_ids.includes(ticket.id)
          );
                    
          if(combos && combos.length > 0){
            combos.forEach(item => {
              if (item.vendas_atuais == null) {
                item.vendas_atuais = 0;
              }
                   
              if(item.total_vagas == null){
                item.total_vagas = item.quantidade_vagas_disponivel;
              }
                            
              if(item.total_vagas <= ticket.total_vagas){
                item.total_vagas = ticket.total_vagas; 
                if(ticket.total_vagas > item.quantidade_vagas_disponivel ){
                  item.total_vagas = item.quantidade_vagas_disponivel;
                }
              }
            });
          }
        }
      }
    },
    roundMoney(value) {
      const precision = 2;
      const cents = Math.floor(value * 100);
      const formattedValue = parseFloat((value * 100).toFixed(precision));
      const formattedCents = parseFloat(cents.toFixed(precision));
            
      if (formattedValue > formattedCents) {
        return (cents + 1) / 100;
      }
      return cents / 100;
    },
    calculateTaxForNetValue(price, rate) {
      if (rate <= 0) {
        return 0;
      }
            
      const rateDecimal = rate / 100;
      const netValue = price;
      const grossValue = netValue / (1 - rateDecimal);
      const correctedTax = grossValue - netValue;
      return this.roundMoney(correctedTax);
    }
  }
};
</script>

<style scoped>
.faixa-container{
    width: 100%;
    border-bottom: 1px solid #DFDFDF;
    
}
.faixa-option {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
   
}

.faixa-option-info {
    line-height: 18px;
    font-size: 14px;
    width: 79%;
}
.faixa-option-quantity {
    width: 20%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.faixa-option-quantity-display {
    width: 40px;
    height: 40px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    border-radius: 12px;
    color: #464646;
}

.faixa-mobile-option {
    padding-top: 20px;
    padding-bottom: 20px;
    border-top: 1px solid #CCCCCC;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-left: -30px;
    margin-right: -30px;
    padding-right: 30px;
    padding-left: 30px;
}

.faixa-mobile-option-info {
    line-height: 18px;
    font-size: 14px;
    width: 74%;
}
.faixa-mobile-option-quantity {
    width: 25%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.faixa-mobile-option-quantity-display {
    width: 40px;
    height: 40px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    border-radius: 12px;
    color: #464646;
}


.compliance-alert {
    padding: 10px;
    border-radius: 12px;
    background-color: #f1f1f1;
}
.fa-plus{
    cursor: pointer;
}
.disabled-quantity {
    cursor: not-allowed; font-size: 10px; border: 1px solid #ACACAC; border-radius: 100%; color: #ACACAC;
    pointer-events: none; 
}
.add-quantity{
    cursor: pointer; font-size: 10px; border: 1px solid #FF9A36; border-radius: 100%; color: #FF9A36;
}
</style>
